module.exports = Object.freeze({
  ERC20: 'erc20',
  ERC721: 'erc721',
  ERC1155: 'erc1155'
})